import React from 'react';

export const pageMeta = {
  "name": "JS Errors",
  "link": "/javascript/errors"
};

export default function JavascriptErrors() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Errors</h2>
      <p>Route: /javascript/errors</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
